import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

export function ViewModal(props) {
  console.log(props);

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    className='videoModal'>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {
            props?.viewType.toLowerCase() == "video".toLowerCase() ?
              "Video"
              : "Image"
          }
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {
          props?.viewType.toLowerCase() == "video".toLowerCase() ?
            <video
              width="600"
              controls
              controlsList="nodownload"
              className='modalContent'
            >
              <source src={props?.url} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            :
            <img src={props?.url} alt={props?.url} width={600} className='modalContent' />
        }
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}